import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import React from "react";
import type { IWithPrevNextNavigationViewModel } from "viewModels/types";

export interface PrevNextNavigationHeaderProps {
  vm: IWithPrevNextNavigationViewModel;
}

function PrevNextNavigationHeader(props: PrevNextNavigationHeaderProps) {
  const { vm } = props;

  return (
    <div className="d-flex justify-content-start align-items-center">
      <Button
        disabled={!vm.hasPrevious || vm.isBusy}
        onClick={vm.onPreviousClick}
        iconLeft={IconType.ArrowLeft}
        variant="light"
        className="mr-3"
      />
      <h3 className="mb-0">{vm.name}</h3>
      <Button
        disabled={!vm.hasNext || vm.isBusy}
        onClick={vm.onNextClick}
        iconLeft={IconType.ArrowRight}
        variant="light"
        className="ml-3"
      />
    </div>
  );
}

export default PrevNextNavigationHeader;
